import { Loadlist } from '@/models/LoadlistModel';
import pako from 'pako';
export async function getExamples(): Promise<Loadlist[]> {
  const r = await fetch('/static/examples.json.gz');
  const blb = await r.blob();
  const buffer = await blb.arrayBuffer();
  return JSON.parse(pako.inflate(buffer, { to: 'string' })) as Loadlist[];
}
